import { useTranslation } from "react-i18next";
import "../../styles/mapStyles/SearchResultPanel.css";
import SoilPopupContent from "./SoilPopupContent";

function SearchResultPanel({
  locationName,
  coordinates,
  soilData,
  recommendation,
  loading,
  error,
  hasRequestedSoilData,
  onGetSoilInfo,
  onClose,
}) {
  const { t } = useTranslation();

  if (!locationName && !loading && !error) return null;


  const shouldShowSoilContent = hasRequestedSoilData || loading || !!soilData || !!error;

  return (
    <div className="search-panel-overlay">
      <div className="search-panel">
        <div className="search-panel-header">
          <div className="search-panel-header-content">
            <strong className="search-panel-title">📍 {t("search.searchedLocation")}</strong>
            <p className="search-panel-coordinates">{locationName}</p>

            {coordinates && (
              <p className="search-panel-coordinates">
                {coordinates.lat.toFixed(5)}°N, {coordinates.lng.toFixed(5)}°E
              </p>
            )}
          </div>

          <button
            className="search-panel-close-btn"
            onClick={onClose}
            aria-label={t("search.closeSearchResultPanel")}
          >
            ✕
          </button>
        </div>

        <hr className="search-panel-divider" />

        <div className="search-panel-body">
          {!shouldShowSoilContent && (
            <button className="get-soil-info-btn" onClick={onGetSoilInfo}>
              {t("soil.getSoilInformation")}
            </button>
          )}

          {shouldShowSoilContent && (
            <SoilPopupContent
              placeName={locationName}
              coordinates={coordinates}
              soilData={soilData}
              recommendation={recommendation}
              loading={loading}
              error={error}
              disableGetInfo={true}
              onGetSoilInfo={null}
              isClickMarker={false}
              onRemoveMarker={null}
              isExactMatch={soilData?.is_exact_match}           
              confidenceScore={soilData?.confidence_score}
              confidenceInterpretation={soilData?.interpretation}
              pointsUsed={soilData?.points_used}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchResultPanel;
